import { IVendorPaymentBankExport } from "@shared/lib/types/briefCampains";
import { Button, Popconfirm, Upload } from "@shared/ui";
import { Download, Upload as UploadIcon } from "lucide-react";
import { formatPayoutAmount, formatPayoutDate } from "../../lib/payoutDisplay";
import styles from "./styles.module.scss";

function getSheetUrl(sheetId: string) {
  return `https://docs.google.com/spreadsheets/d/${sheetId}`;
}

type PayoutExportsPanelProps = {
  exports: IVendorPaymentBankExport[];
  isUploading: boolean;
  isCancelling: boolean;
  onUpload: (exportId: string, file: File) => void;
  onCancel: (exportId: string) => void;
};

export function PayoutExportsPanel({
  exports,
  isUploading,
  isCancelling,
  onUpload,
  onCancel,
}: PayoutExportsPanelProps) {
  return (
    <div className={styles.panel}>
      <div className={styles.heading}>Payment files</div>
      {exports.length === 0 ? (
        <p className={styles.empty}>No payment files are waiting for upload.</p>
      ) : (
        <div className={styles.list}>
          {exports.map((item) => {
            const sheetUrl = item.exportGoogleSheetId
              ? getSheetUrl(item.exportGoogleSheetId)
              : null;
            return (
              <div key={item._id} className={styles.row}>
                <div>
                  <div className={styles.fileNo}>{item._id}</div>
                  <div className={styles.meta}>
                    {formatPayoutDate(item.createdAt)} ·{" "}
                    {item.vendorPaymentIds.length} payout
                    {item.vendorPaymentIds.length === 1 ? "" : "s"} ·{" "}
                    {formatPayoutAmount(item.totalAmount)} · {item.status}
                  </div>
                </div>
                <div className={styles.actions}>
                  {sheetUrl ? (
                    <Button
                      href={sheetUrl}
                      target="_blank"
                      icon={<Download size={13} />}
                    >
                      Download
                    </Button>
                  ) : null}
                  <Upload
                    accept=".csv,text/csv,text/plain"
                    showUploadList={false}
                    disabled={isUploading}
                    beforeUpload={(file) => {
                      onUpload(item._id, file);
                      return false;
                    }}
                  >
                    <Button
                      type="primary"
                      loading={isUploading}
                      icon={<UploadIcon size={13} />}
                    >
                      Upload
                    </Button>
                  </Upload>
                  <Popconfirm
                    title="Cancel this payment file?"
                    description="Cancel only if it has not been uploaded to the bank. Every payout in the file will be cancelled."
                    okText="Cancel file"
                    okButtonProps={{ danger: true, loading: isCancelling }}
                    onConfirm={() => onCancel(item._id)}
                  >
                    <Button danger>Cancel file</Button>
                  </Popconfirm>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
